import { useEffect } from "react";

let lockCount = 0;
let savedStyles = null;

function applyScrollLock() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  savedStyles = {
    htmlOverflow: document.documentElement.style.overflow,
    bodyOverflow: document.body.style.overflow,
    bodyPaddingRight: document.body.style.paddingRight,
  };

  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";

  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
}

function releaseScrollLock() {
  if (!savedStyles) return;

  document.documentElement.style.overflow = savedStyles.htmlOverflow;
  document.body.style.overflow = savedStyles.bodyOverflow;
  document.body.style.paddingRight = savedStyles.bodyPaddingRight;
  savedStyles = null;
}

export function useScrollLock(locked) {
  useEffect(() => {
    if (!locked) return undefined;

    lockCount += 1;
    if (lockCount === 1) {
      applyScrollLock();
    }

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        releaseScrollLock();
      }
    };
  }, [locked]);
}
